export type PlatformModuleKey =
  | 'system'
  | 'billingCatalog'
  | 'materialsCatalog'
  | 'platformGrants'
  | 'auditLogs'
  | 'regulatoryDirectory';

const PLATFORM_MODULE_PERMISSIONS: Record<PlatformModuleKey, readonly string[]> = {
  system: ['platform.system.view'],
  billingCatalog: ['platform.system.view'],
  materialsCatalog: ['platform.materialCatalog.view', 'platform.materialCatalog.manage'],
  platformGrants: ['platform.grants.view'],
  auditLogs: ['platform.audit.view'],
  regulatoryDirectory: [
    'regulatoryDirectory.view',
    'regulatoryDirectory.review',
    'regulatoryDirectory.manage',
    'regulatoryDirectory.merge',
  ],
};

export const PLATFORM_STATION_DIAGNOSTICS_REQUIRED_PERMISSIONS = [
  'platform.system.view',
  'platform.stationDiagnostics.view',
] as const;

export function canAccessPlatformModule(
  permissions: readonly string[] | null | undefined,
  module: PlatformModuleKey,
): boolean {
  const platformPermissions = permissions ?? [];
  return PLATFORM_MODULE_PERMISSIONS[module].some((permission) =>
    platformPermissions.includes(permission),
  );
}

export function canAccessPlatformStationDiagnostics(
  permissions: readonly string[] | null | undefined,
): boolean {
  const platformPermissions = permissions ?? [];
  return PLATFORM_STATION_DIAGNOSTICS_REQUIRED_PERMISSIONS.every((permission) =>
    platformPermissions.includes(permission),
  );
}

export function resolveDefaultPlatformPath(
  permissions: readonly string[] | null | undefined,
): string | null {
  if (canAccessPlatformModule(permissions, 'system')) {
    return '/platform/system';
  }

  if (canAccessPlatformModule(permissions, 'auditLogs')) {
    return '/platform/system/audit-logs';
  }

  if (canAccessPlatformModule(permissions, 'materialsCatalog')) {
    return '/platform/system/materials-catalog';
  }

  if (canAccessPlatformModule(permissions, 'regulatoryDirectory')) {
    return '/platform/regulatory-directory';
  }

  if (canAccessPlatformModule(permissions, 'platformGrants')) {
    return '/platform/system/platform-grants';
  }

  return null;
}
